import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import Emitter from '@utils/eventEmitter'

export const getReportCompanyList = createAsyncThunk(
  'GET_REPORT_COMPANY_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/report/company`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response,
    }
  }
)

export const getHistoryReportCompanyList = createAsyncThunk(
  'GET_HISTORY_REPORT_COMPANY_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/report/`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return response
  }
)

export const getIsReport = createAsyncThunk(
  'GET_IS_REPORT',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/report/isreport`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response,
    }
  }
)

export const createReport = createAsyncThunk(
  'CREATE_REPORT',
  async (data) => {
    let options = {
      method: 'POST',
      url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/report`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      data: response
    }
  }
)

const reportSlice = createSlice({
  name: 'report',
  initialState: {
    isLoading: false,
    companyList: [],
    isReport: false,
    historyCompanyList: [],
  },
  reducers: {
    clearCompanyList: (state) => {
      state.companyList = []
    },
    clearIsReport: (state) => {
      state.isReport = false
    }
  },
  extraReducers: {
    [getReportCompanyList.pending]: (state) => {
      state.isLoading = true
    },
    [getReportCompanyList.rejected]: (state) => {
      state.isLoading = false
    },
    [getReportCompanyList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.companyList = payload.data
    },
    [getIsReport.pending]: (state) => {
      state.isLoading = true
    },
    [getIsReport.rejected]: (state) => {
      state.isLoading = false
    },
    [getIsReport.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.isReport = payload.data
    },
    [createReport.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.isReport = false

      Emitter.emit('SHOW_MESSAGE', {
        text: '등록되었습니다.'
      })
    },
    [getHistoryReportCompanyList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.historyCompanyList = payload
    },
  }
})

export const {clearCompanyList, clearIsReport} = reportSlice.actions

export default reportSlice.reducer